import { BaseInitAppService } from '@shared/core';
import { Observable } from 'rxjs';

export function appInitFactory(initAppService: BaseInitAppService): () => Observable<void> {
    return () => {
        return initAppService.initApp();
    };
}
